import { Api } from "@/plugins/api"

export const organisationExistByNeq = (neq) => {
  return Api.get("/organisations/exists-by-neq?neq=" + neq)
}

export const NeqExistsForAnotherOrganisation = (neq, organisationId) => {
  return Api.get("/organisations/exists-by-neq?neq=" + neq +"&organisationId=" + organisationId)
}